import { useCallback } from "react";

import { useDialogsProvider } from "2g-dialogs-provider";
import ZpracDialog from "2g-zprac-dialog";

import { DATA } from "b2b/api/paths";
import useMessages from "b2b/components/zadosti-odbaveni-grid/i18n/useMessages";

export default function useZadostiOdbaveniToolbar({ reload, selectedId }) {
  const visible = !!selectedId?.length;
  const { dialogAcceptTitle, dialogDeclineTitle } = useMessages();
  const { showDialog, hideDialog } = useDialogsProvider();

  const handleSuccess = useCallback(() => {
    if (reload) {
      reload();
    }
  }, [reload]);

  const onClickPotvrdit = useCallback(() => {
    showDialog(ZpracDialog, {
      method: "put",
      onClose: hideDialog,
      onChangeRequested: hideDialog,
      onSuccess: handleSuccess,
      payload: selectedId,
      title: dialogAcceptTitle(),
      url: DATA.zadostiPotvrzeni()
    });
  }, [dialogAcceptTitle, selectedId]);

  const onClickZamitnout = useCallback(() => {
    showDialog(ZpracDialog, {
      method: "put",
      onClose: hideDialog,
      onChangeRequested: hideDialog,
      onSuccess: handleSuccess,
      payload: selectedId,
      title: dialogDeclineTitle(),
      url: DATA.zadostiZamitnuti()
    });
  }, [dialogDeclineTitle, selectedId]);

  return {
    onClickPotvrdit,
    onClickZamitnout,
    visible
  };
}
